// routes/DashboardRoute.jsx
import { Navigate } from "react-router-dom";

import SuperAdminDashboard from "layouts/dashboard";
import AdminDashboard from "layouts/dashboard/AdminDashboard";
import LeaderWorkerDashboard from "layouts/dashboard/LeaderDashboard";

const DashboardRoute = () => {
  const role = localStorage.getItem("role");
console.log("User role:", role); 
  if (role === "Super_Admin") {
    return <SuperAdminDashboard />;
  }

  if (role === "Admin") {
    return <AdminDashboard />;
  }

  if (role === "Leader" || role === "Worker") {
    return <LeaderWorkerDashboard />;
  }

  return <Navigate to="/authentication/sign-in" />;
};

export default DashboardRoute;
